<script lang="ts">
  export let size = 54;
</script>

<svg width={size} height={size} viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_4254_112827)">
    <rect
      x="24"
      y="20"
      width="40"
      height="40"
      rx="20"
      fill="#F7F7F7"
      fill-opacity="0.08"
      shape-rendering="crispEdges"
    />
    <path
      d="M47 46L41 40L47 34"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="24.5"
      y="20.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="#F7F7F7"
      stroke-opacity="0.08"
      shape-rendering="crispEdges"
    />
  </g>
  <defs>
    <filter
      id="filter0_d_4254_112827"
      x="0"
      y="0"
      width="88"
      height="88"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.0308167 0 0 0 0 0.0179167 0 0 0 0 0.179167 0 0 0 0.04 0"
      />
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4254_112827" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_4254_112827"
        result="shape"
      />
    </filter>
  </defs>
</svg>
